<template>
  <div class="incoming-pickup">
    <div style="height: 0.41rem"></div>
    <Headbar :backgroundColor="'linear-gradient(270deg, #FFE6C6 0%, #FF8432 100%)'" :text="'接站'"></Headbar>
    <div class="warp" v-if="state == 1">
      <template v-if="!(status == 10 || status == 20)">
        <div class="warp-header">
          <p>
            <img src="@assets/pick_up_car.png" alt="" />
            <span>{{ car.useDate }}</span>
          </p>
          <p>
            <span>{{
              getCustomStatusMap(status, 1)
            }}</span>
          </p>
        </div>
        <div class="master-information">
          <span class="label">接站人：</span>
          <div class="master-name">
            <span>{{ car.name }}</span>
          </div>
          <div class="master-contact">
            <span @click="sendSms">发短信</span>
            <span @click="callPhone"> 打电话</span>
          </div>
        </div>
        <div class="master-tips" v-if="status == 30 || status == 40 || status == 50">
          <span>接站人员会提前联系您，请您保持电话畅通</span>
        </div>
        <div class="station-information">
          <div class="station-time">
            <span class="time">
              <span class="cricle"></span>{{ car.plannedArrivalTime | formatTime }}</span>
            <span class="tips">计划接站时间</span>
          </div>
          <div class="from-to">
            <div class="from-to-left">
              <p>
                <img src="@assets/start.svg" alt="" />
              </p>
              <p class="line"></p>
              <p>
                <img src="@assets/end.svg" alt="" />
              </p>
            </div>
            <div class="from-to-right">
              <p class="van-multi-ellipsis--l2">
                <span class="van-multi-ellipsis--l2">
                  <!-- {{
                    car.pickupPoint || "--"
                  }} -->
                {{ pickupPointDetail }}</span>
              </p>

              <p class="van-multi-ellipsis--l2">
                <span class="van-multi-ellipsis--l2">{{
                  car.dropoffPoint || "--"
                }}</span>
              </p>
            </div>
          </div>
        </div>
        <!-- <div class="master-line" v-if="status == 30"></div> -->
        <!-- <div class="master-btn" v-if="status == 30" @click="handleAction">
          <span>无需接站</span>
        </div> -->
      </template>
      <noData v-if="status == 10" :icon="require('@assets/self.png')" :title="'无需接站'"
        :text="'您已设置为无需接站，如需安排接站请联系您的专属秘书'">
      </noData>
      <template v-if="status == 20">
        <noData :text="'最晚在您到达前一天，安排接站'" :algin="'center'" :icon="require('@assets/car_no_data.png')"></noData>
        <!-- <div class="master-btn" @click="handleAction">
          <span>无需接站</span>
        </div> -->
      </template>
    </div>
    <div class="warp" v-else>
      <noData :icon="require('@assets/self.png')" :title="'无需接站'" :text="'您已设置为无需接站，如需安排接站请联系您的专属秘书'">
      </noData>
    </div>
  </div>
</template>


<script>
  import utils from '@utils/index.js'
  import noData from '@components/Common/NoData.vue'
  import Headbar from './Headbar.vue'
  import ListItem from '@components/Common/ListItem.vue'
  export default {
    components: {
      Headbar,
      ListItem,
      noData
    },
    props: {
      car: {
        type: Object,
        default: {}
      },
      receptionPlaces: {
        type: Array,
        default: []
      },
      state: {},
      status: {},
      dictsCodeMap: {}
    },
    computed: {
      pickupPointDetail() { // 上车点详情
        // data.type: 1 来程 2返程
        // data.pickupPoint // 接车地
        // data.dropoffPoint // 目的地
        // receptionPlaces: 接待点列表

        // item.type: 类型1 接站 2送站 3住宿 4订票
        // item.placeName: 接待点名称
        // item.id: 接待点id
        // item.placeDesc // 接待点详情
        if (this.receptionPlaces && this.receptionPlaces.length && this.car) {
          const val = { // 用那些字段来匹配接待点详情
            placeName: this.car.pickupPoint,
            type: this.car.type // 1 接站
          }
          const tmp = this.receptionPlaces.find(item => {
            const keys = Object.keys(val)
            return keys.every(key => item[key] == val[key])
          }) || {}
          return tmp.placeDesc || '--'
        }
        return this.car && this.car.pickupPoint || '--'
      }
    },
    data() {
      return {
        utils
      }
    },
    filters: {
      formatTime(val) {
        if (!val) return
        // 接送站时间来自接口字符串，统一格式化避免 split 时间缺失时报错。
        return utils.dealFormData(val, 'Y-m-d h:m:s').slice(0, 16)
      }
    },
    methods: {
      getCustomStatusMap(status, type) {

        const customMap = {
          '20': '待安排',
          '71': type == 1 ? '他人已接站' : '他人已送站'
        }

        const txt = customMap[status] || this.dictsCodeMap["guest_cab_status"][status + ""]

        return utils.dealDictText(
          txt,
          type
        )

      },
      callPhone() {
        window.location.href = 'tel://' + this.car.phone
      },
      sendSms() {
        window.location.href = 'sms:' + this.car.phone
      },
      handleAction() {
        this.$emit('handleAction', {
          ...this.car,
          type: 1
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .incoming-pickup {
    .warp {
      margin-top: -1rem;
      background: #fff;
      padding: 0 0.29rem 0.21rem;
      border-radius: 0.41rem;

      .warp-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 1.64rem;

        p:nth-child(1) {
          display: flex;
          align-items: center;

          >img {
            width: 0.74rem;
            height: 0.74rem;
            margin-right: 0.16rem;
          }

          >span {
            font-size: 0.57rem;
            font-weight: 500;
            color: #162b40;
          }
        }

        p:nth-child(2) {
          display: flex;
          align-items: center;

          >span {
            font-size: 0.57rem;
            color: #0072f5;
          }
        }
      }

      .master-information {
        position: relative;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 2.3rem;

        padding: 0 0.3rem;
        background: #eff2f9;
        border-radius: 0.26rem;

        .label {
          display: flex;
          font-size: 0.45rem;
          color: rgba(22, 43, 64, 0.45);
        }

        .master-name {
          flex: 1;
        }

        .master-name span {
          font-size: 0.57rem;
          font-weight: 500;
          color: #162b40;
          text-align: left;
        }

        .master-contact {
          display: flex;
          align-items: center;

          >span {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 2.87rem;
            height: 1.31rem;
            background: #ffffff;
            border-radius: 0.62rem;
            font-size: 0.57rem;
            color: #162b40;
          }

          span:nth-child(1) {
            margin-right: 0.41rem;
          }
        }
      }

      .master-tips {
        position: relative;
        z-index: 1;
        margin-top: -0.3rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 1.6rem;
        padding-top: 0.3rem;
        border-radius: 0.26rem;
        border: 0.04rem solid #ececec;

        >span {
          font-size: 0.45rem;
          color: rgba(22, 43, 64, 0.45);
        }
      }

      .station-information {
        margin-top: 0.41rem;
        padding-bottom: 0.21rem;
      }

      .station-time {
        display: flex;
        flex: 1;
        align-items: start;
        margin-bottom: 0.41rem;

        .cricle {
          width: 0.21rem;
          height: 0.21rem;
          background: rgba(22, 43, 64, 0.45);
          border-radius: 100%;
          margin-right: 0.16rem;
        }

        .time {
          display: flex;
          align-items: center;

          font-size: 0.56rem;
          font-weight: 500;
          color: #162b40;
        }

        .tips {
          margin-left: 0.42rem;
          display: flex;
          flex: 1;
          font-size: 0.45rem;
          color: rgba(22, 43, 64, 0.45);
        }
      }

      .from-to {
        display: flex;
        position: relative;

        p {
          display: flex;
          align-items: flex-start;

          >span {
            margin-top: -0.09rem;
            margin-left: 0.16rem;
            font-size: 0.57rem;
            color: rgba(22, 43, 64, 0.85);
          }

          >img {
            width: 0.82rem;
            height: 0.57rem;
          }
        }

        .from-to-left {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;

          p:nth-child(3) {
            height: 1.5rem;
          }

          p:nth-child(1) {
            height: auto;
          }
        }

        .from-to-right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          p:nth-child(2) {
            height: 1.5rem;
          }

          p:nth-child(1) {
            height: auto;
          }
        }

        .line {
          margin: 0.53rem 0.81rem;
          width: 0.02rem;
          height: 0.68rem;
          background: #dcdee0;
        }
      }

      .master-line {
        width: 10.26rem;
        height: 0.02rem;
        margin: 0 auto;
        background: #ececec;
      }

      .master-btn {
        display: flex;
        align-items: center;
        cursor: pointer;
        height: 1.64rem;
        justify-content: center;

        >span {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          flex: 1;
          font-size: 0.57rem;
          color: rgba(22, 43, 64, 0.45);
        }
      }
    }

    ::v-deep {
      .no-data {
        background: #fff;
        height: 9.56rem;
        padding: 0.21rem 0;
        overflow: hidden;
        border-radius: 0.41rem;

        >img {
          position: absolute;
          top: 0.21rem;
          left: 0;
          width: 100%;
          bottom: 0.21rem;
          height: 9.56rem;
        }

        >span {
          color: #162b40;
        }
      }
    }
  }
</style>
